<script setup>
import { computed, watch, ref, onBeforeMount } from "vue";
import AppTopbar from "./AppTopbar.vue";
import AppHeader from "./AppHeader.vue";
import AppFooter from "./AppFooter.vue";
// import AppSidebar from "./AppSidebar.vue";
import AppConfig from "./AppConfig.vue";
import { useLayout } from "@/layout/composables/layout";
import setUpCounter from "@/components/setUpCounter.vue";
// import { SignalRService } from "../service/signalrService";

const { layoutConfig, layoutState, isSidebarActive } = useLayout();

const outsideClickListener = ref(null);

watch(isSidebarActive, (newVal) => {
  if (newVal) {
    bindOutsideClickListener();
  } else {
    unbindOutsideClickListener();
  }
});

const containerClass = computed(() => {
  return {
    "layout-theme-light": layoutConfig.darkTheme.value === "light",
    "layout-theme-dark": layoutConfig.darkTheme.value === "dark",
    "layout-overlay": layoutConfig.menuMode.value === "overlay",
    "layout-static": layoutConfig.menuMode.value === "static",
    "layout-static-inactive":
      layoutState.staticMenuDesktopInactive.value &&
      layoutConfig.menuMode.value === "static",
    "layout-overlay-active": layoutState.overlayMenuActive.value,
    "layout-mobile-active": layoutState.staticMenuMobileActive.value,
    "p-ripple-disabled": layoutConfig.ripple.value === false,
  };
});
const bindOutsideClickListener = () => {
  if (!outsideClickListener.value) {
    outsideClickListener.value = (event) => {
      if (isOutsideClicked(event)) {
        layoutState.overlayMenuActive.value = false;
        layoutState.staticMenuMobileActive.value = false;
        layoutState.menuHoverActive.value = false;
      }
    };
    document.addEventListener("click", outsideClickListener.value);
  }
};
const unbindOutsideClickListener = () => {
  if (outsideClickListener.value) {
    document.removeEventListener("click", outsideClickListener);
    outsideClickListener.value = null;
  }
};
const isOutsideClicked = (event) => {
  const sidebarEl = document.querySelector(".layout-sidebar");
  const topbarEl = document.querySelector(".layout-menu-button");

  return !(
    sidebarEl.isSameNode(event.target) ||
    sidebarEl.contains(event.target) ||
    topbarEl.isSameNode(event.target) ||
    topbarEl.contains(event.target)
  );
};
</script>

<template>
  <div class="layout-wrapper" :class="containerClass">
    <app-header></app-header>
    <div class="layout-main-container" style="background-color: #e8eaed">
      <div>
        <router-view></router-view>
      </div>
    </div>
    <app-config></app-config>
    <div class="layout-mask"></div>
  </div>
  <setUpCounter></setUpCounter>
  <Toast />
  <app-footer></app-footer>
</template>

<style lang="scss">
.layout-main-container {
  padding: 2rem 4rem 2rem 4rem !important;
}

::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 4px rgba(107, 106, 106, 0.3);
  background-color: #f5f5f5;
}

::-webkit-scrollbar-thumb {
  background-color: rgba(107, 106, 106, 0.3);
}

::-webkit-scrollbar {
  width: 7px !important;
  height: 7px !important;
}

.card {
  border-radius: 7px !important;
  border: none;
}

.p-overlaypanel:before {
  display: none;
}

.p-overlaypanel:after {
  display: none;
}
</style>
